import { render } from "./PaginationDots.vue?vue&type=template&id=20fd4014&ts=true"
import script from "./PaginationDots.vue?vue&type=script&lang=ts"
export * from "./PaginationDots.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__